import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import { CONSUMER } from "common/constant";

import { useUpdateNotificationMutation } from "apis/Notification";

import { getNavigateUrlFromNotification } from "utils";
import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";

import { NotificationMessageBox, StyledBox } from "./style";

const NotificationCard = ({ notificationData, handleDrawerClose }) => {
  const {
    name: message,
    id: notificationId,
    notificationTypeId,
    notificationType,
    createdAt: notificationTime,
    utilityId,
    isRead,
  } = notificationData;

  const roles = useSelector((state) => state.Login.roles);
  const navigate = useNavigate();

  const [markNotificationAsRead] = useUpdateNotificationMutation();

  const handleNotificationRead = async (notificationId) => {
    try {
      await markNotificationAsRead(null, { notificationId });
    } catch (error) {}
  };

  const handleClick = async () => {
    if (!isRead) {
      await handleNotificationRead(notificationId);
    }
    const navigateUrl = getNavigateUrlFromNotification(
      notificationType,
      notificationTypeId,
      !roles.includes(CONSUMER),
      utilityId
    );
    handleDrawerClose();
    navigate(navigateUrl);
  };

  return (
    <NotificationMessageBox isCursorPointer={!!notificationTypeId}>
      <StyledBox onClick={handleClick} isNotificationRead={isRead}>
        <Typography className="my-2" sx={{ fontWeight: !isRead && "bold" }}>
          {message}
        </Typography>
        <Typography className="notification-date">
          {convertUTCDateToLocalDate(notificationTime).format(
            "DD-MM-YYYY HH:mm:ss A"
          )}
        </Typography>
      </StyledBox>
    </NotificationMessageBox>
  );
};

export default NotificationCard;

NotificationCard.propTypes = {
  notificationData: PropTypes.object,
  handleDrawerClose: PropTypes.func,
};
